import store from "@/store";
import makePermission from "@/permissions/makePermission";

export default makePermission((): {
    hasPermission: () => Promise<boolean>;
} => ({
    hasPermission() {
        return Promise.resolve(
            store.getters["auth/isSuperUser"] ||
                store.getters["auth/hasSpecialPermissions"]
        );
    }
}));
